"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(props) {
  var timer = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    warning = _useState4[0],
    setWarning = _useState4[1];
  var clearTimer = function clearTimer() {
    return clearTimeout(timer.current);
  };
  (0, _react.useEffect)(function () {
    if (props.open) {
      timer.current = setTimeout(function () {
        return setOpen(true);
      }, 200);
    } else {
      setOpen(false);
    }
    return function () {
      clearTimer();
    };
  }, [props.open]);
  (0, _react.useEffect)(function () {
    if (open) {
      timer.current = setTimeout(function () {
        return setWarning(true);
      }, 10 * 1000);
    } else {
      setWarning(false);
    }
    return function () {
      clearTimer();
    };
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    anchorEl: document.body
  }, /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], (0, _extends2["default"])({}, props, {
    open: open,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-center rounded-full px-8 py-2 shadow dark:shadow-deep cursor-default select-none dark:border bg-card', {
      'text-gray-medium': !warning,
      'text-orange': warning
    })
  }, "Loading...")));
};
//# sourceMappingURL=index.js.map